import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet, SearchSchemaInput, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

const categorySearchSchema = z.object({
  // nuqs writes spaces as '+', which TanStack Router doesn't decode back to spaces
  categoryName: z
    .string()
    .transform((value) => value.replace(/\+/g, ' '))
    .optional(),
});

const WithdrawalCrumb = () => {
  const { activeTab } = useSearch({ strict: false });
  const label =
    activeTab === 'club'
      ? 'configurationManagement.charges.chargeSubCategory.crumb.clubWithdrawal'
      : activeTab === 'customer'
        ? 'configurationManagement.charges.chargeSubCategory.crumb.customerWithdrawal'
        : 'configurationManagement.charges.chargeSubCategory.crumb.affiliateWithdrawal';

  return <CrumbTitle id={label} icon={PercentageIcon} />;
};

export const Route = createFileRoute('/(app)/configuration-management/charges/$categoryId')({
  validateSearch: (search: SearchSchemaInput) => categorySearchSchema.parse(search),
  loader: () => {
    return {
      crumb: <WithdrawalCrumb />,
      crumbPath: '/configuration-management/charges',
      title: <Translation id="configurationManagement.charges.chargeSubCategory.title.withdrawalCategory" />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
